export default __webpack_public_path__ + "static/media/sergic-neuf-logo-white.5e60b8a4.svg";